<template>
  <action-menu-component :items="items" :label="label" icon="plus" :icon-only="compact" :align="compact ? 'center' : 'left'"
                         wide :disabled="disabled" :trigger-class="triggerClass" @select="$emit('select', $event)"></action-menu-component>
</template>

<script>
import ActionMenuComponent from "@/components/menus/ActionMenuComponent";

/*
 * Menú «Añadir bloque» (FE-052) con los tipos del registro: icono, nombre y
 * descripción de una línea. `compact` es el «+» redondo que va entre bloques.
 */
export default {
  name: "BlockInsertMenu",
  components: {
    ActionMenuComponent
  },
  props: {
    blockTypes: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  computed: {
    items() {
      return Object.entries(this.blockTypes).map(([key, blockType]) => ({
        key,
        label: this.$t(blockType.labelKey),
        description: blockType.descriptionKey ? this.$t(blockType.descriptionKey) : null,
        icon: blockType.icon ?? null,
      }))
    },
    triggerClass() {
      return this.compact
          ? 'inline-flex h-7 w-7 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 shadow-sm hover:text-bpblue hover:border-bpblue disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-bpblue'
          : 'inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-100 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue'
    }
  }
}
</script>
